import styled from 'styled-components';
import { level1Content } from '../../../styles/shareableStyles';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px;
  align-items: flex-start;
  ${level1Content};
`;

export const Title = styled.div`
  color: ${theme.colors.secondary900};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;

export const NotificationsSettings = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
  width: 464px;
`;

export const ActionRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
`;
